import { Injectable } from "@angular/core";
import { AttachmentsStore } from "../../store/attachments";
import { map, Observable, of } from "rxjs";
import { MCFormisForm, MCGeneratorFieldsService, MCResponse, MC_RESPONSE_STATUS_CODE, MCSectionSchema, MCUnionRequestHttpWrapperService } from "@maslul/common-services";
import { FieldsMapperService } from "../../fields/mapper";
import { FormlyFieldConfig } from "@ngx-formly/core";
import cloneDeep from "clone-deep";
import { RequestApprovalTypeDetailsStore } from "../../store/approval-type-details-store";

@Injectable({ providedIn: 'root' })
export class AttachmentsService {

    constructor(
        private attachmentsStore: AttachmentsStore,
        private generatorFieldsService: MCGeneratorFieldsService<MCUnionRequestHttpWrapperService<any>>,
        private fieldsMapperService: FieldsMapperService,
        private requestApprovalTypeDetailsStore: RequestApprovalTypeDetailsStore
    ) {

    }



    getFields(formisForm: MCFormisForm): Observable<Array<FormlyFieldConfig> | undefined> {
        const approvalTypeId = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTypeId;

        try {
            const snapshot = this.attachmentsStore.getSnapshot();
            const storedSchemas = snapshot.fieldsSchema;
            if (storedSchemas && Array.isArray(storedSchemas) && storedSchemas.length > 0) {
                console.log('Generating fresh fields from stored schemas...');
                const freshFields = this.fieldsMapperService.generateSchema(storedSchemas, formisForm);
                return of(freshFields);
            }
            else {
                return this.generatorFieldsService.getAttachmentsFields([parseInt(approvalTypeId)])
                    .pipe(map((res: MCResponse) => {
                        if (res && res.code === MC_RESPONSE_STATUS_CODE.SUCCESS) {
                            const schemas: Array<MCSectionSchema> = res.data as Array<MCSectionSchema>;
                            const generatedSchema: Array<FormlyFieldConfig> = this.fieldsMapperService.generateSchema(schemas, formisForm);
                            this.attachmentsStore.setFieldsSchema(cloneDeep(schemas));
                            this.attachmentsStore.setFormisFormFields(cloneDeep(generatedSchema));
                            return generatedSchema;
                        }
                        else {
                            throw new Error(res.data)

                        }
                    }));
            }
        }
        catch (ex) {
            console.error('getAttachmentsFields', ex);
            return of(undefined)
        }
    }

}